import { Routes, Route, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut, SignIn, RedirectToSignIn } from '@clerk/clerk-react'
import { AuthLayout } from '@/components/layouts/AuthLayout'
import { DashboardLayout } from '@/components/layouts/DashboardLayout'
import { LandingPage } from '@/pages/LandingPage'
// import { LoginPage } from '@/pages/auth/LoginPage'
// import { RegisterPage } from '@/pages/auth/RegisterPage'
import { DashboardPage } from '@/pages/dashboard/DashboardPage'
import { ServersPage } from '@/pages/servers/ServersPage'
import { ServerDetailPage } from '@/pages/servers/ServerDetailPage'
import { CreateServerPage } from '@/pages/servers/CreateServerPage'
import { CodeExecutionPage } from '@/pages/code-execution/CodeExecutionPage'
// import { TeamsPage } from '@/pages/teams/TeamsPage'
import { SettingsPage } from '@/pages/settings/SettingsPage'
// import { TemplatesPage } from '@/pages/templates/TemplatesPage'
import { AnalyticsDashboard } from '@/pages/analytics/AnalyticsDashboard'
import { PrivacyPage, TermsPage, CookiePage } from '@/pages/LegalPages'
import { AboutPage, CareersPage, PressPage, PartnersPage, BlogPage } from '@/pages/CompanyPages'
import { HelpPage, CommunityPage, ContactPage, SecurityPage } from '@/pages/SupportPages'

function App() {
  return (
    <Routes>
      {/* Public landing when signed out; redirect to dashboard when signed in */}
      <Route
        path="/"
        element={
          <>
            <SignedOut>
              <LandingPage />
            </SignedOut>
            <SignedIn>
              <Navigate to="/dashboard" replace />
            </SignedIn>
          </>
        }
      />

      {/* Clerk-hosted SignIn route */}
      <Route
        path="/auth/login"
        element={
          <>
            <SignedOut>
              <AuthLayout>
                <SignIn routing="path" path="/auth/login" />
              </AuthLayout>
            </SignedOut>
            <SignedIn>
              <Navigate to="/dashboard" replace />
            </SignedIn>
          </>
        }
      />

      {/* Keep register route to preserve links; could also redirect to SignUp if enabled */}
      <Route
        path="/auth/register"
        element={<Navigate to="/auth/login" replace />}
      />

      {/* Public legal routes */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/cookies" element={<CookiePage />} />

      {/* Public company routes */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/press" element={<PressPage />} />
      <Route path="/partners" element={<PartnersPage />} />
      <Route path="/blog" element={<BlogPage />} />

      {/* Public support routes */}
      <Route path="/help" element={<HelpPage />} />
      <Route path="/community" element={<CommunityPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/security" element={<SecurityPage />} />

      {/* Protected routes require SignedIn; otherwise redirect to sign in */}
      <Route
        path="/*"
        element={
          <>
            <SignedIn>
              <DashboardLayout>
                <Routes>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/servers" element={<ServersPage />} />
                  <Route path="/servers/new" element={<CreateServerPage />} />
                  <Route path="/servers/:id" element={<ServerDetailPage />} />
                  <Route path="/servers/:serverId/code-execution" element={<CodeExecutionPage />} />
                  {/* <Route path="/templates" element={<TemplatesPage />} /> */}
                  {/* <Route path="/teams" element={<TeamsPage />} /> */}
                  <Route path="/analytics" element={<AnalyticsDashboard />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </DashboardLayout>
            </SignedIn>
            <SignedOut>
              <RedirectToSignIn redirectUrl="/auth/login" />
            </SignedOut>
          </>
        }
      />
    </Routes>
  )
}

export default App 